// src/features/live/LiveChips.tsx — chip row that genuinely filters
// (filterLive.ts). Thin wrapper around the shared FilterChips (slice-4-xl S4
// — this used to be identical to Videos' VideoChips apart from the generic type).
import { FilterChips } from '@/components/FilterChips/FilterChips';
import type { ChipDef } from './meta';
import type { LiveChipId } from '@/core/models/live';

export interface LiveChipsProps {
  chips: ChipDef[];
  active: LiveChipId;
  onChange: (id: LiveChipId) => void;
}

export function LiveChips({ chips, active, onChange }: LiveChipsProps) {
  return <FilterChips chips={chips} active={active} onChange={onChange} ariaLabel="Live filters" />;
}
